import PropTypes from 'prop-types';
import { apiCall } from '../../API';
import { createParagraphNode, isNotEmpty } from '../../Components/Fuse/FuseWysiwyg/utils';
import BoolStore from '../helpers/BoolStore';
import RawValueStore from '../helpers/RawValueStore';
import { MetadataPropType, CUSTOMIZATION_TYPE } from './CustomizeUIConstants';
import EntityFormStore from '../helpers/EntityFormStore';
import TextStore from '../helpers/TextStore';
import ValueStore from '../helpers/ValueStore';

export default class CustomizeExitIsolationStore extends EntityFormStore {
    static _PropType = {
        ...EntityFormStore._PropType,
        option: ValueStore.PropTypes,
        text: TextStore.PropTypes,
        isCustomMessageEditable: PropTypes.func,
        metadata: MetadataPropType,
        visible: BoolStore.PropTypes,
    };

    static PropType = PropTypes.shape(CustomizeExitIsolationStore._PropType);

    constructor(data = { }) {
        super(/** @class CustomizeExitIsolationStore */{
            option: new ValueStore('DEFAULT'),
            content: new RawValueStore([createParagraphNode()]),
        }, /** @class CustomizeExitIsolationStore */{
            apiLoad: apiCall('/console/exit_message/get'),
            apiUpdate: apiCall('/console/exit_message/update'),
            isCustomMessageEditable: () => this.option.equals('CUSTOM'),
            metadata: {
                customizationType: CUSTOMIZATION_TYPE.EXIT_MESSAGE,
                type: 'Notification',
                name: 'Exit Isolation',
                description: 'Warn users before exiting Isolation.',
            },
            visible: new BoolStore(true),
        }, data);

        this.content.setValidator(isNotEmpty);
    }

    isValid = () => {
        if (!this.option.equals('DEFAULT') && !this.content.isValid()) {
            return false;
        }
        return true;
    };


    _load = this.load;
    load = (...args) => this._load(...args).then((result) => {
        if (!result?.content && result?.text) {
            this.content.setValue([createParagraphNode([{ text: result.text }])]);
        }

        return result;
    });
}
